import { Box, SimpleGrid, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { BibtexResearcherSync } from '@/module/Dashboard/BibtexResearcherSync';
import { ProfileData } from '@/module/Dashboard/ProfileData';
import { ScopusResearcherSync } from '@/module/Dashboard/ScopusResearcherSync';
import { WosIsiReportSection } from '@/module/Dashboard/WosIsiReportSection';
import { WosResearcherSync } from '@/module/Dashboard/WosResearcherSync';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';
import { UserDocumentsCard } from '@/module/UserDocument/components/UserDocumentsCard';

export interface DashboardProps {
  profileDetails: ProfileDetails;
}

export function Dashboard({ profileDetails }: DashboardProps) {
  const { t } = useTranslation();

  return (
    <Box p="lg">
      <Text
        mt="xl"
        fw="500"
        size="3xl"
      >
        {t('dashboard.welcome')}
      </Text>
      <SimpleGrid
        mt="xl"
        cols={{ base: 1, lg: 2 }}
      >
        <ProfileData profileData={profileDetails} />
        <WosResearcherSync profileDetails={profileDetails} />
        <UserDocumentsCard />
        <BibtexResearcherSync />
        <ScopusResearcherSync profileDetails={profileDetails} />
        <WosIsiReportSection />
      </SimpleGrid>
    </Box>
  );
}
